export default {
  document: 'Dokument',
  note: 'Note',
  esdh_system: 'ESDH-system',
  journalise_to_esdh_system: 'Journaliser i ESDH-system',
  journalise_to_system: 'Journaliser i {system}',
  no_esdh_system_specified: 'Din kommune har endnu ikke opsat et modtagende ESDH-system.',
  exceeded_regarding_children_warning_1:
    'Følgende filer kan ikke blive sendt til journalisering i {systemName}, fordi de omhandler flere end 28 børn.',
  exceeded_regarding_children_warning_2:
    'Nævnte filer bliver fjernet fra listen og bliver ikke sendt til journalisering i {systemName}.',
  sending_documents_to_esdh_system_information: 'Du er ved at sende følgende filer til {systemName}.',
  total_selected_files: 'Antal filer markeret til journalisering i {systemName}: {total}',
  esdh_export_information: 'Filer bliver kun journaliseret for de børn, der er markeret med flueben.',
  journalization_in_progress: 'Journalisering i gang',
  journalization_completed: 'Filen er journaliseret i {systemName}',
  journalized: 'Journaliseret',
  journalization_failed: 'Journalisering fejlede',
  no_regarding_children_warning_1:
    'Følgende filer kan ikke sendes til journalisering i {systemName}, fordi der ikke er mindst et barn tilknyttet.',
  no_regarding_children_warning_2:
    'De filer bliver derfor fjernet fra listen af filer, der bliver journaliseret i {systemName}.',
  sending_document_warning:
    'Du er ved at sende <strong>{number}</strong> fil til {systemName}. | Du er ved at sende <strong>{number}</strong> filer til {systemName}.',
  document_locked_warning:
    'Filerne vil derefter blive {lockedText}, hvilket betyder, at du IKKE vil kunne redigere filerne efter afsendelse.',
  unlock_being_exported_document_warning:
    'Denne fil er i gang med at blive journaliseret, derfor kan den ikke låses op på nuværende tidspunkt.',
  export_being_journalized_again_warning_1:
    'Det er ikke muligt at journalisere filer, der er i gang med at blive journaliseret.',
  export_being_journalized_again_warning_2:
    'Nævnte filer er allerede sendt til journalisering i {systemName} {extendedMessage}',
  export_being_journalized_again_warning_3: 'og bliver derfor fjernet fra listen',
  file_is_being_journalized: 'Filen er under journalisering',
  can_not_unlock_file_being_exported:
    'Denne fil er i gang med at blive journaliseret, derfor kan den ikke låses op på nuværende tidspunkt.',
  can_not_journalize_already_journalized_document:
    'Denne fil er allerede journaliseret og kan ikke blive journaliseret igen.',
  no_export_permission_warning_1:
    'Du har valgt en eller flere filer, du ikke har rettighed til at journalisere {extendedMessage}',
  no_export_permission_warning_2: 'som vil blive fjernet fra eksportlisten',
  no_recipients_configured_warning: 'Din kommune har ikke opsat et modtagende ESDH-system.',
  no_files: 'Der er ingen filer.',
  remove_association: 'Fjern tilknytning',
  remove_association_without_edit_right_warning:
    'Din tilknytning til følgende filer bliver {notText} fjernet, da du ikke har redigeringsrettighed til dem:',
  continue_without_listed_files_confirmation: 'Vil du fortsætte uden nævnte filer?',
  remove_association_warning_1: 'Hvis du fortsætter, bliver din tilknytning til de valgte sikre filer fjernet.',
  remove_association_warning_2: 'Det betyder, at du mister adgang og redigeringsret til dem.',
  number_of_selected: 'Antal valgte filer: {number}',
  functionalities: 'Fil funktionaliteter',
  select_all: 'Vælg alle dokumenter',
  exceeded_pdf_export_warning:
    'Du kan kun eksportere op til {total} filer. Hvis du vil fortsætte, skal du afmarkere mindst {remove} filer.',
  import_new_file: 'Importer ny fælles fil',
  edit_file: 'Rediger fil',
  file_association: 'Hvem skal filen vises for?',
  file_association_help_text:
    'Vælg hele institutionen, specifikke profiltyper i institutionen eller søg efter en gruppe.',
  file_association_note:
    'Bemærk, hvis du angiver både profiltype og gruppe, vil alle brugere, der opfylder mindst ET af disse kriterier, kunne se filen. Det betyder, at hvis filen er delt med alle medarbejdere og en gruppe, vil alle ansatte på institutionen OG alle medlemmer af gruppen kunne se filen - også selvom de er børn eller forældre.',
  one_child_selected_warning: 'Mindst ét barn skal være tilknyttet filen.',
  deleted_files_description: 'Her kan du se og gendanne alle slettede noter og sikre filer fra din institution.',
  input_case_number: 'Angiv sagsnummer',
  add_case_number: 'Tilføj sagsnummer',
  close_case_number: 'Luk felt til angivelse af sagsnummer',
  missing_case_number: 'Angiv sagsnummer eller luk feltet for at fortsætte ',
  revision_created: 'Fil oprettet',
  revision_edited: 'Fil redigeret',
  revision_deleted: 'Fil slettet',
  revision_exported: 'Eksporteret som pdf',
  revision_restored: 'Fil gendannet',
  revision_shared: 'Delt med: {userName}',
  revision_unshared: 'Fjernet deling med: {userName}',
  revision_implicit_unshared: 'Fjernet automatisk deling med: {userName}',
  revision_unlocked: 'Fil låst op',
  revision_locked: 'Fil låst',
  revision_permission_added: 'Redigeringsret tildelt: {userName}',
  revision_permission_removed: 'Redigeringsret fjernet: {userName}',
  revision_journalized_to_esdh: 'Filen er journaliseret i {recipientName}',
};
